import React from 'react';

import './css/index.scss';

class Terms extends React.Component {

  constructor (props) {
    super(props);
    this.state = {
      
    };
  }
  
  componentDidMount(){
    window.scrollTo(0, 0);
    document.title = "Taburi.ro - Termeni și Condiții";
  }

  componentWillUnmount(){
    document.title = "Taburi.ro - Tabulaturi pentru chitară, pian și alte instrumente";
  }

  render () {
    return (
      <div className="termsContainer">
        <div className="mainHeader"></div>
        <div className="container">
          <div className="article" style={{ marginTop: '-200px'}}>
            <h1>Termeni și condiții</h1>
            <div>
<p>              
Utilizarea de către dumneavoastră a site-urilor web taburi.ro, app.taburi.ro, api.taburi.ro şi www.taburi.ro (denumite în continuare "taburi.ro", sau "site-ul web") este guvernată de Termenii şi Condiţiile din acest document. Prin utilizarea taburi.ro confirmaţi că acceptaţi Termenii şi Condiţiile.
</p><p>
Vă obligaţi să utilizaţi propria adresă de e-mail la înregistrarea pe site-ul web.
</p><p>
Nu aveţi dreptul să trimiteţi pe sau prin intermediul site-ului web:
- viruşi informatici sau orice e menit să întrerupă sau să combată operarea normală a unui calculator
- materiale defăimătoare, ameninţătoare, obscene, sau vulgare, sau materiale care ar viola sau încălca în vreun fel drepturile celorlalţi (inclusiv drepturile de proprietate intelectuală, de confidenţialitate, sau cele la intimitate) sau ce ar cauza inconvenienţe ori s-ar afla în contradicție cu legile în vigoare.
</p><p>
taburi.ro nu oferă garanţii de nici un fel privind acurateţea, calitatea satisfăcătoare, şi gradul de utilitate pentru un anumit scop a informaţiilor de pe site-ul web. taburi.ro nu garantează că site-ul web va funcţiona fără întreruperi sau erori, sau că serverul care permite accesul la site-ul web nu are probleme tehnice. taburi.ro nu acceptă responsabilitatea şi nu poate fi tras la răspundere ca urmare a oricăror prejudicii sau daune, directe sau indirecte, rezultate din sau în legatură cu utilizarea site-ului web.
</p><p>
Nu aveţi dreptul să exprimaţi pe site-ul web opinii vulgare, sexiste, rasiste sau ofensatoare în vreun fel.
</p><p>
Site-ul web poate să conţină legături web către terţe site-uri sau materiale care nu se află sub controlul taburi.ro. taburi.ro nu acceptă responsabilitatea şi nu poate fi tras la răspundere ca urmare a oricăror prejudicii sau daune care rezultă din sau sunt legate de accesul terţelor site-uri web prin intermediul legăturilor web disponibile din taburi.ro.
</p><p>
Dacă nu acceptaţi aceşti Termeni şi Condiţii, nu aveţi drept de acces pe site-ul web şi trebuie să încetaţi imediat folosirea lui.
</p><p>
taburi.ro îşi rezervă dreptul de a modifica Termenii şi Condiţiile, facând publice aceste modificări pe site-ul web.
</p>
<h1>Protecţia datelor personale</h1>
<p>
taburi.ro prelucreaza datele dumneavoastră cu bună credință. Datele sunt prelucrate în scopuri legitime și determinate (gestionarea contului personal pe site-ul web și prevenirea fraudelor și a abuzului).
</p><p>
Există două categorii de date pe care le prelucrăm:
</p><p>
A) Datele furnizate de dumneavoastră
Acestea reprezintă datele personale pe care ni le furnizaţi la crearea contului (cum ar fi adresa de email). Este posibil să colectăm şi să stocăm informaţiile pe care le furnizaţi atunci când folosiţi taburi.ro introducând informaţii în cadrul unui formular electronic sau când corespondaţi cu noi în alt mod.
</p><p>
Păstrăm adresa de email pe durata existenței contului dumneavoastră de utilizator taburi.ro. Adresele de email stocate de căre taburi.ro nu sunt divulgate sub nicio formă către altcineva. De asemenea, nu trimitem mesaje de email nesolicitate către adresa dumneavoastră de email în scopuri de marketing. Atunci când solicitați acest lucru, taburi.ro vă poate trimite mesaje de email legate exclusiv de administrarea contului de utilizator (de exemplu, recuperarea parolei uitate) sau notifări cu privire la care ați optat explicit să fiți informat. Din oficiu, nu trimitem notificări de vreun fel fără acordul dumneavoastră.
</p><p>
B) Datele colectate automat
De fiecare când accesați site-ul web de pe calculatorul sau dispozitivul dumneavoastră mobil, stocăm sau interogăm așa-numitele mici fișiere "cookies" pe calculatorul sau dispozitivul dumneavoastră mobil. Pentru a afla mai multe despre cookies, vizitați https://ro.wikipedia.org/wiki/Cookie.
</p><p></p><p>

taburi.ro utilizează atât cookies proprii, cât și cookies de la Google, care de asemenea are obligația legală sau contractuală de a vă proteja datele. Cookies-urile proprii ne ajută să vă oferim funcționalitatea propriu-zisă a site-ului web, prin a vă identifica unic ca și utilizator. De asemenea, fișierele cookies ne ajută să gestionăm preferințele pe care le aveți cu privire la utilizarea site-ului web, și sunt necesare din motive de securitate.
</p><p>
Puteţi refuza stocarea fișierelor cookies dacă browser-ul dumneavoastră o permite, cu excepţia situaţiei în care fișierele cookies sunt necesare pentru a preveni frauda sau pentru a asigura securitatea site-ului web pe care îl controlăm. Cu toate acestea, această acțiune poate interfera cu utilizarea site-ului nostru.
</p><p>
Aveti următoarele drepturi: dreptul de acces la date, dreptul de rectificare a datelor (de exemplu, când sunt incomplete), dreptul de ștergere a datelor, dreptul la restricționarea datelor, dreptul la portabilitatea datelor, dreptul de a obiecta, dreptul de a nu fi supus unei decizii individuale automatizate, dreptul de a vă adresa Autorității Nationale pentru Supravegherea Prelucrării Datelor cu Caracter Personal, dreptul de a retrage oricând consimțământul de marketing direct.
</p><p>
Pentru exercitarea acestor drepturi, actualizați datele sau schimbați opţiunile din contul dumneavoastră de utilizator. Pentru ştergerea definitivă a datelor, accesați pagina de contact (accesibilă la https://www.taburi.ro/contact) și scrieți-ne în legătură cu acest subiect sau direct la contact@taburi.ro. Vă vom răspunde în cel mai scurt timp posibil.</p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Terms;



// WEBPACK FOOTER //
// ./src/components/terms/terms.js